import { render } from "./NewTDAParticipantSubscription.vue?vue&type=template&id=d84bf512&scoped=true"
import script from "./NewTDAParticipantSubscription.vue?vue&type=script&lang=js"
export * from "./NewTDAParticipantSubscription.vue?vue&type=script&lang=js"

import "./NewTDAParticipantSubscription.vue?vue&type=style&index=0&id=d84bf512&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d84bf512"]])

export default __exports__